<template>
  <span class="scaling-svg-container">
    <svg
      id="Icon_Info_Circle"
      class="scaling-svg"
      data-name="Icon/Info Circle"
      xmlns="http://www.w3.org/2000/svg"
      width="14.376"
      height="14.376"
      viewBox="0 0 14.376 14.376"
    >
      <path
        id="Icon_Icon_Info"
        data-name="Icon/Icon/Info"
        d="M7.188,14.376a7.188,7.188,0,1,1,7.187-7.187A7.2,7.2,0,0,1,7.188,14.376Zm0-12.938a5.751,5.751,0,1,0,5.75,5.751A5.758,5.758,0,0,0,7.188,1.437Zm0,9.345a.72.72,0,0,1-.719-.719V6.469a.719.719,0,1,1,1.437,0v3.594A.719.719,0,0,1,7.188,10.782Zm0-5.75a.719.719,0,1,1,.718-.719A.72.72,0,0,1,7.188,5.032Z"
        transform="translate(0 0)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class InfoIcon extends Vue {}
</script>

<style>
</style>
